import { z } from 'zod';

import { LanguageEnum } from '../../enums';
import { languageEnumValidator } from '../../validators';

export const ValidateSentenceSchema = z.object({
  language: languageEnumValidator.optional().default(LanguageEnum.RU),
  sentence: z.string().min(1, 'Sentence cannot be empty.'),
});

export type IValidateSentenceDto = z.infer<typeof ValidateSentenceSchema>;
